import React from 'react';
import { ShieldCheckIcon, LayersIcon, UsersIcon } from 'lucide-react';
export function KeyHighlights() {
  return <div className="w-full" style={{
    backgroundColor: '#f8f6f0'
  }} data-id="element-3227">
      <div className="max-w-4xl mx-auto px-4 md:px-8" data-id="element-3228">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12" data-id="element-3229">
          <div className="bg-white rounded-xl p-6 shadow-sm border flex flex-col items-center text-center" style={{
          borderColor: '#ede9e0'
        }} data-id="element-3230">
            <div className="w-12 h-12 rounded-full flex items-center justify-center mb-4" style={{
            backgroundColor: 'rgba(30,61,47,0.08)'
          }} data-id="element-3231">
              <ShieldCheckIcon size={24} style={{
              color: '#1e3d2f'
            }} data-id="element-3232" />
            </div>
            <h3 className="text-lg font-bold uppercase mb-2" style={{
            fontFamily: 'Oswald, sans-serif',
            color: '#1e3d2f'
          }} data-id="element-3233">
              Expert Instructors
            </h3>
            <p className="text-sm" style={{
            color: '#4a6a5a',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-3234">
              Taught by 20-year Fenton Police Department veteran Detective Tom
              Cole and his wife Amy.
            </p>
          </div>

          <div className="bg-white rounded-xl p-6 shadow-sm border flex flex-col items-center text-center" style={{
          borderColor: '#ede9e0'
        }} data-id="element-3235">
            <div className="w-12 h-12 rounded-full flex items-center justify-center mb-4" style={{
            backgroundColor: 'rgba(30,61,47,0.08)'
          }} data-id="element-3236">
              <LayersIcon size={24} style={{
              color: '#1e3d2f'
            }} data-id="element-3237" />
            </div>
            <h3 className="text-lg font-bold uppercase mb-2" style={{
            fontFamily: 'Oswald, sans-serif',
            color: '#1e3d2f'
          }} data-id="element-3238">
              3-Level Curriculum
            </h3>
            <p className="text-sm" style={{
            color: '#4a6a5a',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-3239">
              Progressive training covering situational awareness, escaping
              holds, striking, and blocking.
            </p>
          </div>

          <div className="bg-white rounded-xl p-6 shadow-sm border flex flex-col items-center text-center" style={{
          borderColor: '#ede9e0'
        }} data-id="element-3240">
            <div className="w-12 h-12 rounded-full flex items-center justify-center mb-4" style={{
            backgroundColor: 'rgba(30,61,47,0.08)'
          }} data-id="element-3241">
              <UsersIcon size={24} style={{
              color: '#1e3d2f'
            }} data-id="element-3242" />
            </div>
            <h3 className="text-lg font-bold uppercase mb-2" style={{
            fontFamily: 'Oswald, sans-serif',
            color: '#1e3d2f'
          }} data-id="element-3243">
              Open to Public
            </h3>
            <p className="text-sm" style={{
            color: '#4a6a5a',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-3244">
              Oriented toward women ages 10+, but everyone is welcome. Open to
              members and non-members.
            </p>
          </div>
        </div>
      </div>
    </div>;
}